export default (that = {}) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },

  {
    title: that.$l('INDEX.table_label_name') || '中文名称',
    field: 'columnNameZh',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
    fixed: 'left',
  },

  {
    title: that.$l('INDEX.table_label_logo') || '标识',
    field: 'columnNo',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },


  {
    title: that.$l('INDEX.table_label_Formula') || '公式(点击编辑)',
    field: 'columnValue',
    minWidth: 130,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
    editRender: {
      name: 'input',
      attrs: { type: 'String', placeholder: that.$l('INDEX.table_label_click_edit_formula') || '点击编辑公式' },
    },
  },

  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('INDEX.table_label_calculation_results') || '计算结果',
    field: 'results',
    minWidth: 120,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_delete') || '删除',
    width: 120,
    align: 'center',
    slots: { default: 'del' },
  },
]
